/**
 * Created by slava on 23.03.17.
 */
ComingSoonLocationView.prototype.customize = cleverapps.extendFunc(ComingSoonLocationView.prototype.customize, function () {
    const styles = cleverapps.styles.LocationView.coming_soon;

    this.activities = [];

    this.addCup();
    if (!connector.platform.oneOf(connector.INSTANT, connector.YOUTUBE, connector.GAMESNACK)) {
        this.addJoin();
    }

    const activitiesLayout = new cleverapps.Layout(this.activities, {
        direction: styles.activities.direction,
        reversed: styles.activities.direction === cleverapps.UI.VERTICAL,
        margin: styles.activities.margin
    });
    activitiesLayout.setScale(styles.activities.scale[cleverapps.resolution.mode]);

    const items = [];
    items.unshift(activitiesLayout);

    const text = this.createText();
    if (text) {
        items.unshift(text);
    }

    if (this.animation) {
        items.unshift(this.animation);
        this.animation.setScale(styles.animation.scale);
        this.animation.removeFromParent();
    }

    this.addAnimationText();

    const layout = this.content = new cleverapps.Layout(items, {
        direction: cleverapps.UI.VERTICAL,
        margin: styles.margin
    });

    if (this.animation) {
        this.animation.setAnimation(0, "animation", true);
    }

    layout.setScale(styles.scale);

    this.addChild(layout);
    if (styles.positions) {
        layout.setAlignment(styles.positions[cleverapps.resolution.mode]);
    }
});

ComingSoonLocationView.prototype.addAnimationText = function () {
    const styles = cleverapps.styles.LocationView.coming_soon;

    if (!styles.animation.text || !this.animation) {
        return;
    }

    const animationTextMsg = connector.platform.oneOf(connector.DIGITAL, connector.DIGITALWEB)
        ? "EpisodeView.ComingSoonEpisode.animationText.complete" : "EpisodeView.ComingSoonEpisode.animationText";
    // eslint-disable-next-line no-restricted-syntax
    const text = cleverapps.UI.generateTTFText(Messages.get(animationTextMsg), cleverapps.styles.FONTS.EPISODE_CLOUD_TEXT);
    text.setDimensions(styles.animation.text.width, 0);
    text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
    this.animation.addChild(text);
    text.setAlignment(styles.animation.text);

    const scale = styles.animation.text.height / text.height;
    if (scale < 1) {
        text.setScale(scale);
    }
};

ComingSoonLocationView.prototype.createText = function () {
    const styles = cleverapps.styles.LocationView.coming_soon;

    let msg = this.activities.length > 0 ? styles.text.activitiesMsg : styles.text.noActivitiesMsg;
    if (connector.platform.oneOf(connector.DIGITAL, connector.DIGITALWEB)) {
        msg = this.activities.length > 0 ? styles.text.activitiesCompleteMsg : styles.text.noActivitiesCompleteMsg;
    }
    if (!msg) {
        return;
    }
    // eslint-disable-next-line no-restricted-syntax
    const text = cleverapps.UI.generateTTFText(Messages.get(msg), styles.font);
    text.setDimensions(styles.text.width[cleverapps.resolution.mode] * resolutionScale, 0);
    text.setScale(styles.text.scale[cleverapps.resolution.mode]);
    text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

    return text;
};

ComingSoonLocationView.prototype.createButton = function (text, onClicked) {
    const styles = cleverapps.styles.LocationView.coming_soon;

    return new cleverapps.UI.Button({
        text,
        width: styles.activities.button.width,
        height: styles.activities.button.height,
        onClicked
    });
};

ComingSoonLocationView.prototype.createActivityText = function (text) {
    const styles = cleverapps.styles.LocationView.coming_soon;

    // eslint-disable-next-line no-restricted-syntax
    text = cleverapps.UI.generateTTFText(text, styles.font);
    text.setDimensions(styles.activities.text.width, styles.activities.text.height);
    text.setHorizontalAlignment(styles.activities.text.horizontalAlignment);
    text.setVerticalAlignment(styles.activities.text.verticalAlignment);
    return text;
};

ComingSoonLocationView.prototype.createAnimation = function (json) {
    const styles = cleverapps.styles.LocationView.coming_soon;
    if (!styles.activities.animation) {
        return;
    }

    const animation = new cleverapps.Spine(json);
    animation.setAnimation(0, "animation", true);
    return animation;
};

ComingSoonLocationView.prototype.addCup = function () {
    if (!cleverapps.dailyCup || !cleverapps.dailyCup.isRunning()) {
        return;
    }
    const styles = cleverapps.styles.LocationView.coming_soon;

    const items = [];

    const text = this.createActivityText(Messages.get("EpisodeView.ComingSoonEpisode.cup"));
    items.push(text);

    const button = this.createButton(Messages.get(styles.activities.text.cupMsg), () => {
        cleverapps.focusManager.display({
            focus: "DailyCupSceneFromComingSoon",
            action: function (f) {
                cleverapps.scenes.replaceScene(bundles.main.jsons.dailycupscene_prefab_json, f);
            }
        });
    });
    items.push(button);

    const animation = this.createAnimation(bundles.episode_coming_soon.jsons.cup_json);
    if (animation) {
        items.push(animation);
    }

    this.addActivity(items);
};

ComingSoonLocationView.prototype.addJoin = function () { 
    if (connector.platform.oneOf(connector.AMAZON, connector.DIGITAL, connector.DIGITALWEB)) {
        return;
    }
    const styles = cleverapps.styles.LocationView.coming_soon;

    const items = [];

    const text = this.createActivityText(Messages.get("EpisodeView.ComingSoonEpisode.join"));
    items.push(text);

    const button = this.createButton(Messages.get(styles.activities.text.joinMsg), () => {
        connector.social.joinCommunityCallback();
    });
    items.push(button);

    const animation = this.createAnimation(bundles.episode_coming_soon.jsons.join_json);
    if (animation) {
        items.push(animation);
    }

    this.addActivity(items);
};

ComingSoonLocationView.prototype.addActivity = function (items) {
    const styles = cleverapps.styles.LocationView.coming_soon;

    this.activities.push(new cleverapps.Layout(items, {
        direction: styles.activities.itemsDirection,
        reversed: styles.activities.itemsDirection === cleverapps.UI.VERTICAL,
        margin: styles.activities.itemsMargin
    }));
};

cleverapps.overrideStyles(cleverapps.styles.LocationView, {
    coming_soon: {
        animation: {
            scale: 1.0
        },
        activities: {
            margin: 30,
            itemsMargin: 10,
            text: {
                width: 380,
                horizontalAlignment: cc.TEXT_ALIGNMENT_CENTER,
                verticalAlignment: cc.VERTICAL_TEXT_ALIGNMENT_TOP,
                cupMsg: "Compete",
                joinMsg: "Join"
            },
            button: {
                width: 380
            },
            animation: true,
            scale: [0.8, 1.0, 1.0],
            itemsDirection: cleverapps.UI.VERTICAL,
            direction: cleverapps.UI.HORIZONTAL
        },
        margin: 40,
        text: {
            width: [380, 550, 550],
            scale: [0.9, 1.0, 1.0],
            activitiesMsg: "EpisodeView.ComingSoonEpisode.activities",
            noActivitiesMsg: "EpisodeView.ComingSoonEpisode",
            activitiesCompleteMsg: "EpisodeView.ComingSoonEpisode.activities.complete",
            noActivitiesCompleteMsg: "EpisodeView.ComingSoonEpisode.complete"
        },
        scale: 1.0,
        font: cleverapps.styles.FONTS.EPISODE_CLOUD_TEXT
    }
});
